import { render } from "./module-editor.vue?vue&type=template&id=21d52f30&scoped=true"
import script from "./module-editor.vue?vue&type=script&lang=js"
export * from "./module-editor.vue?vue&type=script&lang=js"

import "./module-editor.vue?vue&type=style&index=0&id=21d52f30&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d52f30"]])

export default __exports__